module.exports = __webpack_public_path__ + "static/media/muted.d7af13e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/muted.svg
// module id = 623
// module chunks = 0